import { CapacityDataType } from '../../types';

type FormData = {
  id: string;
  startDate: string;
  moves: number;
  terminalCode: string;
  moveCountStretchPercentage: number;
  moveCountCriticalPercentage: number;
  capacityDataType: CapacityDataType;
  yardCapacity: number;
  reeferPlugs: number;
  imoUnits: number;
  imoUnitsDescription: string;
  oogUnits: number;
  ladenCapacity: number;
  emptyCapacity: number;
  maxCapacity: number;
  entries: { capacityDataType: CapacityDataType }[];
};

export type DefaultValueDtoSOC = {
  id: string;
  startDate: string;
  moves: number;
  terminalCode: string;
  moveCountStretchPercentage: number;
  moveCountCriticalPercentage: number;
  capacityDataType: CapacityDataType;
  entityType: 'SOC';
  entries: { capacityDataType: CapacityDataType }[];
};

export type DefaultValueDtoYard = {
  id: string;
  startDate: string;
  yardCapacity: number;
  reeferPlugs: number;
  imoUnits: number;
  imoUnitsDescription: string;
  oogUnits: number;
  ladenCapacity: number;
  emptyCapacity: number;
  maxCapacity: number;
  terminalCode: string;
  capacityDataType: CapacityDataType;
  entityType: 'YARD';
  entries: { capacityDataType: CapacityDataType }[];
};

export type DefaultValueDto = DefaultValueDtoYard | DefaultValueDtoSOC;

export const createDefaultValueDto = (formData: FormData, type: 'soc' | 'yard'): DefaultValueDto => {
  if (type === 'soc') {
    return {
      id: formData.id,
      startDate: formData.startDate,
      moves: formData.moves,
      moveCountStretchPercentage: formData.moveCountStretchPercentage,
      moveCountCriticalPercentage: formData.moveCountCriticalPercentage,
      capacityDataType: formData.capacityDataType,
      terminalCode: formData.terminalCode,
      entityType: 'SOC',
      entries: [
        ...formData.entries.filter((x) => x.capacityDataType !== CapacityDataType.Total),
        {
          capacityDataType: CapacityDataType.Total,
          // @ts-ignore
          type: 'SOC',
          moves: formData.moves,
          moveCountStretchPercentage: formData.moveCountStretchPercentage,
          moveCountCriticalPercentage: formData.moveCountCriticalPercentage,
          overwrite: false,
        },
      ],
    };
  }
  return {
    id: formData.id,
    startDate: formData.startDate,
    yardCapacity: formData.yardCapacity,
    reeferPlugs: formData.reeferPlugs,
    imoUnits: formData.imoUnits,
    imoUnitsDescription: formData.imoUnitsDescription,
    oogUnits: formData.oogUnits,
    terminalCode: formData.terminalCode,
    capacityDataType: formData.capacityDataType,
    ladenCapacity: formData.ladenCapacity,
    emptyCapacity: formData.emptyCapacity,
    maxCapacity: formData.maxCapacity,
    entityType: 'YARD',
    entries: [
      ...formData.entries.filter((x) => x.capacityDataType !== CapacityDataType.Total),
      {
        capacityDataType: CapacityDataType.Total,
        // @ts-ignore
        type: 'YARD',
        yardCapacity: formData.yardCapacity,
        reeferPlugs: formData.reeferPlugs,
        imoUnits: formData.imoUnits,
        oogUnits: formData.oogUnits,
        imoUnitsDescription: formData.imoUnitsDescription,
        ladenCapacity: formData.ladenCapacity,
        emptyCapacity: formData.emptyCapacity,
        maxCapacity: formData.maxCapacity,
        overwrite: false,
      },
    ],
  };
};
